<template>
    <base-modal
        modal-id="errorModal"
        modal-dialog="centered,error"
        ref="baseModal"
    >
        <template #title>
            <h5 class="modal-title glitch-text glitch-text--login">Что-то пошло не так..</h5>
        </template>
        <template #default>
            <div class="error-text" data-error-text></div>
        </template>
    </base-modal>
</template>

<script>
import { EVENT_HANDLE_GLOBAL_ERROR } from '../../services/event-bus/event-types';
import BaseModal from './modals/base-modal';

const { eventBus } = window.specialtyApp;

export default {
    name: 'error-handler',
    components: { BaseModal },

    data() {
        return {
            error: null,
        };
    },

    methods: {
        handler(error) {
            console.log(error);
            try {
                this.error = error;
                this.$refs.baseModal.show();
            } catch (e) {
                console.error(e.message);
            }
        },
    },

    computed: {
        errorText() {
            return this.error?.message || 'Системная ошибка, попробуйте попытку позднее';
        },
    },

    created() {
        eventBus.$on(EVENT_HANDLE_GLOBAL_ERROR, this.handler);
    },
};
</script>
